import {
  AccountProductEnum,
  PillButton,
  PillButtonRowComponent,
  SmartViewNavigationAction,
} from '@varo/graphql-schema-types';
import { getSourceName } from 'features/accounts/AccountDetails/AccountDetails.helpers';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Pill from 'shared/components/vxl/navigation/Pill/Pill';
import theme from 'shared/styles/theme';

interface SmartViewTabsProps {
  navigationTab: PillButtonRowComponent;
  handleSmartViewTabPress: (onClick: SmartViewNavigationAction) => void;
  selectedTab: string | null | undefined;
  eventPropsData?: {
    accountType: AccountProductEnum | undefined;
    accountName: string | undefined;
  };
}
const SmartViewTab = ({
  navigationTab,
  selectedTab,
  handleSmartViewTabPress,
  eventPropsData,
}: SmartViewTabsProps) => {
  return (
    <View style={styles.container}>
      {navigationTab?.pills.map(({ title, onClick, id }: PillButton) => {
        return (
          <Pill
            key={id}
            labelText={title.copy}
            onPress={() => {
              handleSmartViewTabPress(onClick);
            }}
            isSelected={onClick.categoryId === selectedTab}
            analyticsId="pillNavigation"
            customAttributes={{
              source_name: getSourceName(onClick.categoryId) as string,
              insights_category: getSourceName(
                onClick.categoryId,
                true,
              ) as string,
              cta: title.copy,
              account_type: eventPropsData
                ? (eventPropsData.accountType?.toLowerCase() as string)
                : '',
              category: (eventPropsData?.accountType ===
              AccountProductEnum.Checking
                ? eventPropsData.accountType.toLowerCase()
                : eventPropsData?.accountName?.toLowerCase()) as string,
            }}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flexDirection: 'row',
    gap: 8,
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.s,
  },
});

export default SmartViewTab;
